import { Selector } from '@ngxs/store';
import { VoucherState, VoucherStateModel } from './voucher.state';

export class VoucherStateSelectors {
  @Selector([VoucherState])
  static voucher(state: VoucherStateModel) {
    return state.claimedVoucher;
  }

  @Selector([VoucherState])
  static voucherId(state: VoucherStateModel): string {
    return state.claimedVoucher?.voucherId;
  }

  @Selector([VoucherState])
  static voucherAmount(state: VoucherStateModel): number {
    return state.claimedVoucher?.voucherAmount?.amountIncludingVAT || 0;
  }
}
